import { isClient } from '#/utils/general';

export interface HubspotConversationsLoadOptions {
  widgetOpen?: boolean;
}

export interface HubspotConversationsRefreshOptions {
  openToNewThread?: boolean;
}

export interface HubspotConversations {
  /**
   * Load the Hubspot widget.
   */
  load: (options?: HubspotConversationsLoadOptions) => void;
  /**
   * Refresh the Hubspot widget.
   */
  refresh: (options?: HubspotConversationsRefreshOptions) => void;
  /**
   * Open the Hubspot widget.
   */
  open: () => void;
  /**
   * Close the Hubspot widget.
   */
  close: () => void;
  /**
   * Remove the Hubspot widget.
   */
  remove: () => void;
  /**
   * Get the status of the Hubspot widget.
   * @returns the status of the Hubspot widget
   */
  status: () => { loaded: boolean };
}

export interface Hubspot {
  conversations: HubspotConversations;
}

const conversations: HubspotConversations = {
  load: (options?: HubspotConversationsLoadOptions) => {
    const hs = getHubspotConversations();
    if (hs) {
      hs.load(options);
    }
  },
  refresh: (options?: HubspotConversationsRefreshOptions) => {
    const hs = getHubspotConversations();
    if (hs) {
      hs.refresh(options);
    }
  },
  open: () => {
    const hs = getHubspotConversations();
    if (hs) {
      hs.open();
    }
  },
  close: () => {
    const hs = getHubspotConversations();
    if (hs) {
      hs.close();
    }
  },
  remove: () => {
    const hs = getHubspotConversations();
    if (hs) {
      hs.remove();
    }
  },
  status: () => {
    const hs = getHubspotConversations();
    if (hs) {
      return hs.status();
    }
    return { loaded: false };
  },
};

export default { conversations } satisfies Hubspot;

/*
|------------------
| Internals
|------------------
*/

function getHubspotConversations(): HubspotConversations | null {
  if (isClient()) {
    // @ts-expect-error - HubSpotConversations is not typed
    return window.HubSpotConversations.widget;
  }
  return null;
}
